var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRiskStatus = function SvgRiskStatus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91386 1.5758L3.55499 3.14014C2.58343 3.59262 1.94229 4.60593 2.00411 5.71816C2.24581 10.0664 3.46094 11.9807 6.61839 14.2207C7.45484 14.8141 8.55742 14.8155 9.39325 14.2212C12.5604 11.969 13.7321 10.0276 13.995 5.73322C14.0635 4.61364 13.4214 3.58957 12.443 3.13393L9.09748 1.5758C8.40239 1.25208 7.60895 1.25208 6.91386 1.5758ZM7.33335 11.333C7.33335 10.9648 7.63183 10.6663 8.00002 10.6663C8.36821 10.6663 8.66669 10.9648 8.66669 11.333C8.66669 11.7012 8.36821 11.9997 8.00002 11.9997C7.63183 11.9997 7.33335 11.7012 7.33335 11.333ZM7.50002 9.33301C7.50002 9.60915 7.72388 9.83301 8.00002 9.83301C8.27616 9.83301 8.50002 9.60915 8.50002 9.33301L8.50002 4.66634C8.50002 4.3902 8.27616 4.16634 8.00002 4.16634C7.72388 4.16634 7.50002 4.3902 7.50002 4.66634L7.50002 9.33301Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRiskStatus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "risk-status.70d99bf5b1048a78f8729b9e5d68c93f.svg";